/** @format */
import { BreadCrumb } from "components";
import { ButtonExport } from "components/Button";
import { useDashboard } from "hooks/HookBos/useDashboard";
import React, { useEffect, useState } from "react";
import { shallowEqual, useSelector } from "react-redux";
import { useHistory } from "react-router";
import {
  getDetailRealisasiExport,
  getDetailRencanaExport,
} from "services/v2/notificationservice";
import { TableDetail } from "./Component/CardTable";
import { FilterForm } from "./Component/FilterForm";

const ROLE_ALLOWED_EXPORT_DETAIL = [
  "admin_pusat",
  "admin_pusat_bos",
  "auditor_pusat_internal",
  "auditor_pusat_external",
  "pembuat_kebijakan_pusat",
  "admin_provinsi",
  "admin_provinsi_bos",
  "pokjawas_provinsi",
  "pengawas_provinsi",
  "pembuat_kebijakan_provinsi",
  "admin_kabkota",
  "admin_kabkota_bos",
  "pengawas",
  "pembuat_kebijakan_kabkota",
];

const DashboardDetails = () => {
  const route = useHistory();
  const { auth } = useSelector(
    (state: any) => ({
      auth: state.auth?.data || null,
    }),
    shallowEqual,
  );
  const [filter, setFilter] = useState<any>({});
  const [pagination, setPagination] = useState<{
    current: number;
    pageSize: number;
  }>({
    current: 1,
    pageSize: 10,
  });
  const [exporting, setExporting] = useState(false);

  const dataState: any = route ? route.location.state : null;
  const itemBreadcrumb = [
    { path: "/", breadcrumbName: "Home" },
    {
      path: "/",
      breadcrumbName:
        dataState?.pagu === "indikatif" ? "Dashboard Indikatif" : "Dashboard",
    },
    { path: "/", breadcrumbName: "Detail" },
    { path: "/", breadcrumbName: dataState?.title || "" },
  ];
  const { dataDetail, getDataDetail, loading } = useDashboard(auth);
  useEffect(() => {
    if (dataState?.type) {
      const payload = {
        status: dataState?.status,
        page: pagination.current,
        size: pagination.pageSize,
        ...filter,
      };
      const link =
        dataState?.pagu === "indikatif"
          ? `detail-${dataState?.type}-${dataState?.pagu}-perpage`
          : `detail-${dataState?.type}-perpage`;
      getDataDetail(link, payload);
    }
  }, [dataState, getDataDetail, pagination, pagination.pageSize, filter]);
  // "dashboard/detail-rencana-perpage"

  const canExportDetail =
    dataState?.pagu !== "indikatif" &&
    (dataState?.type === "rencana" || dataState?.type === "realisasi") &&
    ROLE_ALLOWED_EXPORT_DETAIL.includes(auth?.kode_role);

  const handleExport = async () => {
    setExporting(true);

    const exportFn =
      dataState?.type === "realisasi"
        ? getDetailRealisasiExport
        : getDetailRencanaExport;

    const exportParams: any = {
      tahun: auth?.isTahun,
      status: dataState?.status,
      ...filter,
    };

    if (auth?.group_role !== "pusat") {
      exportParams.kodeProvinsi = auth?.kode_provinsi;
    }

    if (!["pusat", "provinsi"].includes(auth?.group_role)) {
      exportParams.kodeKabKota = auth?.kode_kabkota;
    }

    await exportFn(exportParams, auth);

    setExporting(false);
  };

  return (
    <>
      <BreadCrumb
        routes={itemBreadcrumb}
        title={dataState?.title || ""}
        back={true}
        toBack={() =>
          route.push({
            pathname:
              dataState?.pagu === "indikatif"
                ? "../dashboard-indikatif"
                : "../dashboard",
          })
        }
      />
      <div className="m-5 p-5 bg-white shadow-sm">
        <div className="flex items-start gap-2 float-right mb-5">
          <FilterForm
            formLayout="inline"
            handleFilter={(values) =>
              setFilter({
                kodeProvinsi: values?.provinsi,
                kodeKabKota: values?.kabkota,
                nsm: values?.madrasah,
                kodeSumberDana: values?.kodeSumberDana,
              })
            }
            loading={loading}
          />
          {canExportDetail && (
            <ButtonExport
              title="Unduh Excel"
              loading={exporting}
              onClick={handleExport}
            />
          )}
        </div>

        <TableDetail
          type={
            dataState?.pagu === "indikatif"
              ? "rencanaIndikatif"
              : dataState?.type || ""
          }
          title={""}
          data={dataDetail}
          pagination={pagination}
          loading={loading}
          handlePageChange={(page, pageSize) => {
            setPagination({ current: page, pageSize });
          }}
        />
      </div>
    </>
  );
};

export default DashboardDetails;
